angular.module('picmonicng').component('educatorBrowseTree', {
  templateUrl: '/templates/app/components/educator-browse-tree/educator-browse-tree.html',
  bindings: {
    ngModel: '<',
    userId: '<',
    start: '<',
    end: '<',
    classId: '<',
  },
  controller: [
    '$http',
    'PlaylistService',
    function ($http, PlaylistService) {
      var ctrl = this;
      var stickyPathway;
      var stickyTrack;
      ctrl.PlaylistService = PlaylistService;

      ctrl.getSections = function () {
        ctrl.initialLoading = true;
        $http
          .get('/api/v3/educator_data/sections', {
            params: {
              user_id: ctrl.userId,
              start: ctrl.start,
              end: ctrl.end,
              school_class_id: ctrl.classId,
            },
          })
          .then(function (data) {
            ctrl.sections = data.data;
            ctrl.initialLoading = false;
            if (stickyPathway) {
              angular.forEach(data.data[stickyPathway.section_name].pathways, function (p) {
                if (p.pathway_id === stickyPathway.pathway_id) {
                  data.data[stickyPathway.section_name].open = true;
                  p.open = true;
                  ctrl.getTracks(p);
                }
              });
            }
          });

        $http
          .get('/api/v3/educator_data/playlists', {
            params: {
              user_id: ctrl.userId,
              start: ctrl.start,
              end: ctrl.end,
              school_class_id: ctrl.classId,
            },
          })
          .then(function (data) {
            ctrl.playlists = data.data;
          });
      };

      ctrl.getTracks = function (pathway) {
        stickyPathway = {
          pathway_id: pathway.pathway_id,
          section_name: pathway.section_name,
        };
        if (pathway.tracks) {
          return;
        }
        var l = $http.get('/api/v3/educator_data/tracks', {
          params: {
            user_id: ctrl.userId,
            start: ctrl.start,
            end: ctrl.end,
            school_class_id: ctrl.classId,
            pathway_id: pathway.pathway_id,
          },
        });
        l.then(function (data) {
          pathway.tracks = data.data;
          if (stickyTrack) {
            angular.forEach(data.data, function (p) {
              angular.forEach(p.tracks, function (t) {
                if (t.track_id === stickyTrack.track_id) {
                  p.open = true;
                  t.open = true;
                  ctrl.getPicmonics(t);
                }
              });
            });
          }
        });

        return l;
      };

      ctrl.getPicmonics = function (track) {
        stickyTrack = { track_id: track.track_id };
        if (track.picmonics) {
          return;
        }
        var l = $http.get('/api/v3/educator_data/picmonics', {
          params: {
            user_id: ctrl.userId,
            start: ctrl.start,
            end: ctrl.end,
            school_class_id: ctrl.classId,
            track_id: track.track_id,
          },
        });
        l.then(function (data) {
          track.picmonics = data.data;
        });

        return l;
      };

      ctrl.getPlaylistPicmonics = function (playlist) {
        if (playlist.picmonics) {
          return;
        }
        var l = $http.get('/api/v3/educator_data/playlist_picmonics', {
          params: {
            user_id: ctrl.userId,
            start: ctrl.start,
            end: ctrl.end,
            school_class_id: ctrl.classId,
            playlist_id: playlist.playlist_id,
          },
        });
        l.then(function (data) {
          playlist.picmonics = data.data;
        });

        return l;
      };

      ctrl.$onChanges = function () {
        ctrl.getSections();
      };
    },
  ],
});
